import { Alert, Stack, Typography } from "@mui/material";
import { THistoricoExpedicao } from "../../../../../../types/api/comercial/detalhar-pedido";
import { useMutation, useQuery, useQueryClient } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { IDataDetalheExpedicaoPedido } from "../../../../../../types/api/estoque/detalhar-expedicao";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import BtnLoading from "../../../../../../components/BasicComponents/Buttons/BtnLoading";

export default function BtnEmitirNotaFiscal({
    expedicao
}: PropsBtnEmitirNotaFiscal) {

    const queryClient = useQueryClient();

    const [stopQuery, setStopQuery] = useState(false);

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: [`detalhar-expedicao/${expedicao.id}`, expedicao.id],
        queryFn: () => axiosClient.get("/estoque/detalhar-expedicao/" + expedicao.id),
        keepPreviousData: false,
        refetchOnWindowFocus: true,
        cacheTime: 0,
        enabled: !stopQuery,
        refetchInterval: stopQuery ? false : 3000,
        onSuccess: (data) => {
            if (data.data.status_nf === "Nota fiscal emitida" || data.data.status_nf === "Erro na emissão") {
                setTimeout(() => {
                    queryClient.invalidateQueries("comercial/detalhar-pedido");
                }, 4000);
                setStopQuery(true);
            } else {
                setStopQuery(false);
            }
        },
    });

    const { mutate: tentarNovamente, isLoading: isLoadingRetry } = useMutation({
        mutationKey: 'tentar-novamente-emissao-nota-fiscal',
        mutationFn: (input: number) => axiosClient.put(`/comercial/pedidos/emitir-nota-fiscal/tentar-novamente/${input}`),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao concluir expedição!', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar(`Expedição concluída com sucesso!`, { variant: 'success' });
            queryClient.invalidateQueries("comercial/detalhar-pedido");
            queryClient.invalidateQueries(`detalhar-expedicao/${expedicao.id}`);
            setStopQuery(false);
        }
    })
    const detalheExp: IDataDetalheExpedicaoPedido = data?.data;

    const isErroEmissao: boolean = detalheExp?.status_nf === "Erro na emissão";
    
    const ultimoErro = expedicao.status_nfe_historico && expedicao.status_nfe_historico.length > 0 
        ? expedicao.status_nfe_historico[expedicao.status_nfe_historico.length - 1] 
        : null;
    
    const isErroCS9: boolean = Boolean(
        isErroEmissao && ultimoErro && ultimoErro.origem_erro === "CS9"
    );

    return (
        <>
            {
                detalheExp?.status_nf !== "Nota fiscal emitida" &&
                <Stack spacing={2} mt={2} width="100%" alignItems="flex-end">
                    {
                        detalheExp?.status_nf === "Erro na emissão" && (
                            isErroCS9 ? (
                                <Alert severity="error" variant="standard" sx={{ width: '100%' }}>
                                    {`${ultimoErro?.origem_erro} - ${ultimoErro?.error}`}
                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                        Acione a equipe de T.I para suporte.
                                    </Typography>
                                </Alert>
                            ) : (
                                <Alert severity="error" variant="standard" sx={{ width: '100%' }}>
                                    {`${ultimoErro?.origem_erro} - ${ultimoErro?.error}`}
                                </Alert>
                            )
                        )
                    }

                    {!isErroCS9 && (
                        <BtnLoading
                            size="small"
                            variant="outlined"
                            color="primary"
                            loading={detalheExp?.status_nf === "Emissão em andamento" || isLoadingRetry}
                            loadingText={detalheExp?.situacao ? detalheExp.situacao : "Emitindo..."}
                            disabled={detalheExp?.status_nf !== "Erro na emissão" || isLoading || isLoadingRetry}
                            onClick={detalheExp?.status_nf === "Erro na emissão" ? () => {
                                tentarNovamente(expedicao.id)
                            } : () => { }}
                        >
                            {detalheExp?.status_nf !== "Erro na emissão" ? "Emitir nota fiscal" : "Tentar novamente"}
                        </BtnLoading>
                    )}
                </Stack>
            }
        </>
    )
}

interface PropsBtnEmitirNotaFiscal {
    expedicao: THistoricoExpedicao;
}
